import React from 'react';
import './Contact.css';

const Contact = () => {
    const contacts = [
        { title: 'Support', email: 'support@privateiq.golf' },
        { title: 'Press', email: 'press@privateiq.golf' },
        { title: 'Partnerships', email: 'partnerships@privateiq.golf' },
    ];

    return (
        <nav className="navbar2">
            <div className="contact-page">
                <div className="contact-header">
                    <h1>We're here to help.</h1>
                    <p className="contact-subtitle">Reach out to the right team using the email addresses below:</p>
                </div>

                <div className="contact-content">
                    {contacts.map((contact, index) => (
                        <div className="contact-item" key={index}>
                            <h2 className="contact-title">{contact.title}</h2>
                            <a href={`mailto:${contact.email}`} className="contact-email">
                                {contact.email}
                            </a>
                        </div>
                    ))}
                </div>

                <div className="contact-footer">
                    <p>
                        * For immediate assistance, please allow 24-48 hours for a response. Our team is available
                        Monday through Friday, 9 AM - 5 PM EST.
                    </p>
                </div>
            </div>
        </nav>
            );
            };

            export default Contact;
